import { render, staticRenderFns } from "./treeMenus.vue?vue&type=template&id=3ec67e42&scoped=true&"
import script from "./treeMenus.vue?vue&type=script&lang=js&"
export * from "./treeMenus.vue?vue&type=script&lang=js&"
import style0 from "./treeMenus.vue?vue&type=style&index=0&id=3ec67e42&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ec67e42",
  null
  
)

export default component.exports